import api from '@/services/api'

export default {
  getCurrentClient() {
    return api.get(`get_current_client/`)
        .then(response => response.data)
  },
  getClientsTotal(params) {
    return api.get(`clients/total/`, {params})
        .then(response => response.data)
  },
  getClient(data) {
    return api.get(`clients/${data.client_id}/`, {params: data.params, token: data.token})
        .then(response => response.data)
  },
  getSpecialInfo(data) {
    return api.get(`clients/${data.client_id}/get_special_info/`, {params: data})
        .then(response => response.data)
  },
  getClientInfo(client_id) {
    return api.get(`clients/${client_id}/get_info/`)
        .then(response => response.data)
  },
  getClients(params) {
    return api.get(`clients/`, {params})
        .then(response => response.data)
  },
  getCollectionClients(params) {
    return api.get(`clients/collection_list/`, {params})
        .then(response => response.data)
  },
  editClient(client) {
    return api.put(`clients/${client.id}/`, client)
        .then(response => response.data)
  },
  deleteClient(client_id) {
    return api.delete(`clients/${client_id}/`)
        .then(response => response.data)
  },
  postClient(client) {
    return api.post(`clients/`, client)
        .then(response => response.data)
  },
  editClientBalance(data) {
    return api.put(`clients/${data.client.id}/edit_balance/`, data)
        .then(response => response.data)
  },
  bulkEditClientBalance(data) {
    return api.put(`clients/bulk_edit_balance/`, data)
        .then(response => response.data)
  },
  bulkEditClientPercent(data) {
    return api.put(`clients/bulk_edit_percent/`, data)
        .then(response => response.data)
  },
  bulkEditClientPermissions(data) {
    return api.put(`clients/bulk_edit_permissions/`, data)
        .then(response => response.data)
  },
  sendingVkMessage(data) {
    return api.post(`clients/vk_sending_message/`, data)
        .then(response => response.data)
  },
}